import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const navItems = [
  { name: "首页", path: "/" },
  { name: "企业内幕", path: "/category/corporate-insider" },
  { name: "金融黑幕", path: "/category/financial-scandal" },
  { name: "娱乐揭秘", path: "/category/entertainment-expose" },
  { name: "社会民生", path: "/category/society-livelihood" },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-100/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <nav className="container-custom flex items-center justify-between h-16">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 flex items-center justify-center">
            <i className="ri-spy-fill text-2xl text-primary-500"></i>
          </div>
          <span className="font-heading font-bold text-xl text-foreground-50 tracking-wide group-hover:text-primary-400 transition-colors">
            黑料社区
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const isActive =
              item.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive
                    ? "bg-primary-500/20 text-primary-400"
                    : "text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50"
                }`}
              >
                {item.name}
              </Link>
            );
          })}
        </div>

        {/* Right Actions */}
        <div className="flex items-center gap-3">
          <button className="hidden md:flex items-center gap-1.5 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-950 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer">
            <i className="ri-add-line text-lg w-4 h-4 flex items-center justify-center"></i>
            提交爆料
          </button>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-200/60">
          <div className="container-custom py-4 flex flex-col gap-2">
            {navItems.map((item) => {
              const isActive =
                item.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-primary-500/20 text-primary-400"
                      : "text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50"
                  }`}
                >
                  {item.name}
                </Link>
              );
            })}
            <button className="mt-2 flex items-center justify-center gap-1.5 px-4 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer">
              <i className="ri-add-line text-lg w-4 h-4 flex items-center justify-center"></i>
              提交爆料
            </button>
          </div>
        </div>
      )}
    </header>
  );
}